module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/pisa.b9f0b64f875f78f1f920df51e10c0165.jpg";